import Swal from "sweetalert2";
import guestList from "./guest-list";
import removeGuestButton from "./remove-guest-button";

export default async function(event) {
    const element = event.target;
    const id = element.dataset.id;
    element.setAttribute('disabled', true);
    let guest;
    try {
        guest = await guestList.addGuestById(id);
    } catch (error) {
        console.error('add-guest-button error', error);
        if (error == 'Maximum guest limit') {
            Swal.fire({
                icon: 'error',
                title: 'Guest limit reached',
                text: 'Sorry, you can only add up to ' + guestList.maxGuests + ' guests to this reservation',
            });
        }
        return;
    }
    // Remove add button, regardless of the guest being valid or not
    const parent = element.parentNode;
    element.remove();

    if (guest === false) {
        // Guest isn't valid, so don't add remove button
        parent.remove();
        return;
    }

    const removeButton = document.createElement('button');
    removeButton.classList.add('btn', 'btn-danger', 'cnaq-reserve-form__guest-remove-btn');
    removeButton.innerHTML = 'Remove';
    removeButton.dataset.id = id;
    removeButton.addEventListener('click', removeGuestButton);

    parent.append(removeButton);
}